import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";

const ProfileModal = ({ isOpen, onClose }) => {
  const { user, profile, updateProfile, reloadProfile } = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    profession: "Aspirante a Corredor",
    bio: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  // Cargar datos del perfil
  useEffect(() => {
    if (user && isOpen) {
      console.log("👤 Cargando perfil en modal:", profile);

      setFormData({
        name: profile?.name || user?.user_metadata?.name || "",
        email: user?.email || "",
        phone: profile?.phone || user?.user_metadata?.phone || "",
        profession: profile?.profession || "Aspirante a Corredor",
        bio: profile?.bio || "",
      });
    }
  }, [user, profile, isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ type: "", text: "" });

    console.log("💾 Guardando cambios:", formData);

    const result = await updateProfile({
      name: formData.name,
      phone: formData.phone,
      profession: formData.profession,
      bio: formData.bio,
    });

    if (result.success) {
      // Forzar recarga del perfil
      // await reloadProfile();

      setMessage({ type: "success", text: "Perfil actualizado exitosamente" });
      setTimeout(() => {
        setIsEditing(false);
        setMessage({ type: "", text: "" });
      }, 1500);
    } else {
      setMessage({ type: "error", text: result.error });
    }
    setIsLoading(false);
  };

  const handleEditClick = (e) => {
    e.preventDefault();
    setIsEditing(true);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setFormData({
      name: profile?.name || user?.user_metadata?.name || "",
      email: user?.email || "",
      phone: profile?.phone || user?.user_metadata?.phone || "",
      profession: profile?.profession || "Aspirante a Corredor",
      bio: profile?.bio || "",
    });
    setIsEditing(false);
    setMessage({ type: "", text: "" });
  };

  return (
    <div className="fixed inset-0 z-[200] overflow-y-auto">
      <div className="fixed inset-0 bg-gradient-to-br from-slate-900/95 via-indigo-900/95 to-slate-900/95 backdrop-blur-md" />

      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-2xl transform overflow-hidden rounded-3xl bg-white shadow-2xl animate-slideUp">
          <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500" />

          <div className="px-8 pt-10 pb-8">
            {/* Header */}
            <div className="flex items-center justify-between mb-8">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center text-white text-2xl font-bold shadow-lg">
                  {profile?.name.charAt(0) || user?.email?.charAt(0) || "U"}
                </div>
                <div>
                  <h2 className="text-2xl font-black text-slate-800">
                    Mi Perfil
                  </h2>
                  <p className="text-sm text-slate-500">{user?.email}</p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="p-2 hover:bg-slate-100 rounded-xl"
              >
                <svg
                  className="w-6 h-6 text-slate-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Mensaje */}
            {message.text && (
              <div
                className={`mb-6 p-4 rounded-xl flex items-start gap-3 ${
                  message.type === "success"
                    ? "bg-emerald-50 border border-emerald-200"
                    : "bg-red-50 border border-red-200"
                }`}
              >
                <span
                  className={`text-sm ${
                    message.type === "success"
                      ? "text-emerald-700"
                      : "text-red-700"
                  }`}
                >
                  {message.text}
                </span>
              </div>
            )}

            {/* Formulario */}
            <form onSubmit={handleSubmit}>
              <div className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                      Nombre completo
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      disabled={!isEditing}
                      className={`w-full px-4 py-3 rounded-xl text-sm ${
                        isEditing
                          ? "bg-white border-2 border-blue-200 focus:border-blue-500"
                          : "bg-slate-50 border-2 border-slate-200 text-slate-700 cursor-not-allowed"
                      }`}
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                      Correo electrónico
                    </label>
                    <input
                      type="email"
                      value={formData.email}
                      disabled
                      className="w-full px-4 py-3 rounded-xl text-sm bg-slate-50 border-2 border-slate-200 text-slate-700 cursor-not-allowed"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                      Teléfono
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      disabled={!isEditing}
                      placeholder="+507 6000-0000"
                      className={`w-full px-4 py-3 rounded-xl text-sm ${
                        isEditing
                          ? "bg-white border-2 border-blue-200 focus:border-blue-500"
                          : "bg-slate-50 border-2 border-slate-200 text-slate-700 cursor-not-allowed"
                      }`}
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                      Profesión
                    </label>
                    <input
                      type="text"
                      name="profession"
                      value={formData.profession}
                      onChange={handleChange}
                      disabled={!isEditing}
                      className={`w-full px-4 py-3 rounded-xl text-sm ${
                        isEditing
                          ? "bg-white border-2 border-blue-200 focus:border-blue-500"
                          : "bg-slate-50 border-2 border-slate-200 text-slate-700 cursor-not-allowed"
                      }`}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                    Biografía
                  </label>
                  <textarea
                    name="bio"
                    value={formData.bio}
                    onChange={handleChange}
                    disabled={!isEditing}
                    rows="4"
                    placeholder="Cuéntanos un poco sobre ti..."
                    className={`w-full px-4 py-3 rounded-xl text-sm ${
                      isEditing
                        ? "bg-white border-2 border-blue-200 focus:border-blue-500"
                        : "bg-slate-50 border-2 border-slate-200 text-slate-700 cursor-not-allowed"
                    }`}
                  />
                </div>
              </div>

              {/* Botones */}
              <div className="mt-8 flex items-center justify-end gap-4">
                {!isEditing ? (
                  <>
                    <button
                      type="button"
                      onClick={onClose}
                      className="px-6 py-3 bg-white border-2 border-slate-200 text-slate-700 rounded-xl font-bold hover:bg-slate-50"
                    >
                      Cerrar
                    </button>
                    <button
                      type="button"
                      onClick={handleEditClick}
                      className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-bold shadow-lg shadow-blue-200 hover:shadow-xl hover:scale-105 transition-all flex items-center gap-2"
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                      Editar perfil
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={handleCancel}
                      className="px-6 py-3 bg-white border-2 border-slate-200 text-slate-700 rounded-xl font-bold hover:bg-slate-50"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="px-6 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-xl font-bold shadow-lg shadow-emerald-200 hover:shadow-xl hover:scale-105 transition-all flex items-center gap-2 disabled:opacity-50"
                    >
                      {isLoading ? "Guardando..." : "Guardar cambios"}
                    </button>
                  </>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
